import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetAllChatCommand extends IRequestCommand<IGetAllChatResponse, ErrorDetails, IGetAllChatCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'chats/all?carrierId={carrierId}&role={role}';

    public override setParameters(parameters: IGetAllChatCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId.toString());
        this._commandUrl = this._commandUrl.replace('{role}', parameters.role.toString());
    }
}

export interface IGetAllChatCommandParameters{
    carrierId: number;
    role: string;
}

export interface IGetAllChatResponse {
}
